import { useMutation } from "@tanstack/react-query";
import { createJourneyPreview } from "./api";
import type { JourneyPreviewRequest, JourneyPreviewResponse } from "./types";

/**
 * useJourneyPreviewMutation — preview is computed on-demand (POST), so we
 * use a mutation rather than a query. Callers can read `data` to access
 * the most recent preview.
 */
export function useJourneyPreviewMutation() {
  return useMutation<JourneyPreviewResponse, Error, JourneyPreviewRequest>({
    mutationFn: createJourneyPreview,
  });
}
